<nav class="navbar navbar-expand-lg header text-white">
  <div class="container-fluid">
    <div class="col-6 col-sm-2">
      <img src="assets/images/header-logo.png" class="img-fluid" alt="Logo">
    </div>

    <div class="collapse navbar-collapse">
      <ul class="navbar-nav me-auto">
        @for (menuItem of menuItems; track menuItem) {
          <li class="nav-item"  [ngClass]="{'active': activeMenu === menuItem}" (click)="navigate(menuItem)">
            <span class="label" >{{menuItem.label}}</span>
          </li>
        }
      </ul>
      <form class="d-flex" role="search">
        @if (showLogoutMenu) {
          <span class="logout-button material-symbols-outlined cursor-hand" (click)="logout()">logout</span>
        }
      </form>
    </div>

    <button mat-icon-button [matMenuTriggerFor]="menu" class="navbar-toggler" >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @for (menuItem of menuItems; track menuItem) {
        <button mat-menu-item  (click)="navigate(menuItem)">
          <span class="label" >{{menuItem.label}}</span>
        </button>
      }
      <button mat-menu-item [disabled]="!showLogoutMenu">
        <span class="logout-button material-symbols-outlined cursor-hand" (click)="logout()">logout</span>
      </button>
    </mat-menu>
  </div>
</nav>

<!--
<header class="p-1 ">
  <div class="container">
    <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">

      <ul class="nav col-10 me-lg-auto mb-2 mb-md-0">
        <li class="col-3">

        </li>
        <li *ngFor="let menuItem of menuItems">
          <span class="label">{{menuItem.label}}</span>
        </li>
      </ul>


    </div>
  </div>
</header>
-->
